// extracted by mini-css-extract-plugin
module.exports = {"indicator":"MainLayout_indicator__315es","container":"MainLayout_container__3z1cU"};